import { getAuthLiteHeaders } from 'services/AuthServices.web';
import { RootDispatch, RootState } from 'store/types';
import { GetTestResultDetails, GET_TEST_RESULT_DETAILS } from './actions.common';

export * from './actions.common';

export const getAuthLiteTestResultDetails = ({
  url,
  responseType = ''
}: GetTestResultDetails) => async (dispatch: RootDispatch, getState: () => RootState) => {
  dispatch({
    type: GET_TEST_RESULT_DETAILS,
    payload: {
      request: {
        method: 'get',
        url,
        headers: getAuthLiteHeaders(getState()),
        responseType
      }
    }
  });
};
